import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Tartalmak', instructions: ['/tartalmak']}).add({name: 'Naptár'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/calendar/calendar.component.ts